module.exports = __webpack_public_path__ + "static/media/varejo-tour.c400b2d8.jpg";